import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ToastContainer } from 'react-toastify';

import { StoreProvider } from './_core/appContext';
import { SettingsProvider } from './context/SettingsContext';
import MainApp from './MainApp';

function App() {
   const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? '';

   return (
      <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
         <StoreProvider>
            <SettingsProvider>
               <MainApp />
               <ToastContainer position='top-center' />
            </SettingsProvider>
         </StoreProvider>
      </GoogleReCaptchaProvider>
   );
}

export default App;
